module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-f75c8203.png";